<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>家庭医生工作站</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>问卷调查</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div>
      <el-button type="primary" @click="generatePDF">生成PDF文件</el-button>
    </div>
    <br />

    <div class="d1" ref="pdfContent">
      <div class="title" style="padding-left: 30px">{{ qaName }}</div>
      <div class="d2" v-for="(item, index) in qaItem" :key="index">
        <span class="span1">{{ index + 1 }}. {{ item.content }}</span>
        <br />
        <span class="span2"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
            item.detail
          }}</span
        >
      </div>
    </div>
  </basic-container>
</template>

<script>
import { jsPDF as JsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { getAllQaItem } from "@/api/health/manage";

export default {
  data() {
    return {
      qaItem: [],
      qaName: "",
    };
  },
  created() {
    this.qaName = this.$route.query.qaName;
    this.onLoad();
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId;
      const qaId = this.$route.query.qaId;
      // getQaItem(wxUserId, qaId).then((res) => {
      //   this.qaItem = res.data;
      // });
      getAllQaItem(wxUserId, qaId).then((res) => {
        this.qaItem = res.data;
      });
    },
    async generatePDF() {
      const element = this.$refs.pdfContent;
      const canvas = await html2canvas(element, {
        scale: 2, // 提高清晰度
        useCORS: true, // 允许跨域图片
        backgroundColor: "#FFFFFF", // 设置背景为白色
      });

      const pdfWidthMM = 400; // A4宽度 210mm
      const pdfHeightMM = 400; // A4高度 297mm

      // 计算内容宽高比
      const contentRatio = canvas.height / canvas.width;

      // 宽度填满PDF，高度按比例计算
      const renderWidthMM = pdfWidthMM;
      const renderHeightMM = pdfWidthMM * contentRatio;

      // 转换为PDF使用的点单位（1mm ≈ 2.834点）
      const pdfWidthPt = pdfWidthMM * 2.834;
      const pdfHeightPt = pdfHeightMM * 2.834;
      const renderWidthPt = renderWidthMM * 2.834;
      const renderHeightPt = renderHeightMM * 2.834;

      // 创建PDF（纵向）
      const pdf = new JsPDF({
        orientation: "portrait",
        unit: "pt",
        format: [pdfWidthPt / 2, pdfHeightPt],
      });

      // 添加图像到PDF，水平填满，垂直居中
      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        0, // x坐标从0开始，宽度填满
        0,
        renderWidthPt, // 宽度填满PDF
        renderHeightPt // 高度按比例缩放
      );

      // 保存PDF
      pdf.save(`report_${new Date().toISOString()}.pdf`);
    },
  },
};
</script>

<style scoped>
.title {
  font-weight: 900;
  font-size: 30px;
}
.d1 {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  /* overflow: auto; */
  /* height: 75vh; */
  padding: 20px 10px;
}

.d2 {
  flex: 0 0 calc(100% - 8px);
  box-sizing: border-box;
  padding: 12px;
  border: 1px solid #eee;
  border-radius: 4px;
  padding-right: 50%;
  /* width: 220mm; */

  /* text-align: center; */
}

.span1 {
  font-size: 15px;
  font-weight: 600;
}

.span2 {
  font-size: 15px;
  color: #4e8cf2;
}
</style>
